export default __webpack_public_path__ + "static/media/wakanda.419c3e6c.png";